import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { getIntDictOptions, DICT_TYPE, getStrDictOptions } from '@/utils/dict';
import { ApiKeyApi } from '@/api/ai/model/apiKey';
import { CommonStatusEnum } from '@/utils/constants';
import { reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
/** AI API 密钥 表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'ApiKeyForm'
  },
  __name: 'ApiKeyForm',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    // const { t } = useI18n() // 国际化
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formType = ref(''); // 表单的类型：create - 新增；update - 修改
    const formData = ref({
      id: undefined,
      name: undefined,
      apiKey: undefined,
      platform: undefined,
      url: undefined,
      status: CommonStatusEnum.ENABLE
    });
    const formRules = reactive({
      name: [{
        required: true,
        message: '名称不能为空',
        trigger: 'blur'
      }],
      apiKey: [{
        required: true,
        message: '密钥不能为空',
        trigger: 'blur'
      }],
      platform: [{
        required: true,
        message: '平台不能为空',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '状态不能为空',
        trigger: 'blur'
      }]
    });
    const formRef = ref(); // 表单 Ref
    /** 打开弹窗 */
    const open = async (type, id) => {
      dialogVisible.value = true;
      // dialogTitle.value = t('action.' + type)
      dialogTitle.value = '操作';
      formType.value = type;
      resetForm();
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          formData.value = await ApiKeyApi.getApiKey(id);
        } finally {
          formLoading.value = false;
        }
      }
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        if (formType.value === 'create') {
          await ApiKeyApi.createApiKey(data);
          // message.success(t('common.createSuccess'))
          message.success('创建成功');
        } else {
          await ApiKeyApi.updateApiKey(data);
          // message.success(t('common.updateSuccess'))
          message.success('修改成功');
        }
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        name: undefined,
        apiKey: undefined,
        platform: undefined,
        url: undefined,
        status: CommonStatusEnum.ENABLE
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "所属平台",
            prop: "platform"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.platform,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.platform = $event),
              placeholder: "请输入平台",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getStrDictOptions)(_unref(DICT_TYPE).AI_PLATFORM), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.name = $event),
              placeholder: "请输入名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密钥",
            prop: "apiKey"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.apiKey,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.apiKey = $event),
              placeholder: "请输入密钥"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "自定义 API URL",
            prop: "url"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.url,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.url = $event),
              placeholder: "请输入自定义 API URL"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.status = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: dict.value,
                  value: dict.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});